import React from 'react';
import { formatPeriodLabel, getPeriodPrefix } from '../utils/formatters';
import { isActualPeriod } from '../utils/calendarUtils';
import './UnifiedCalendar.css';

/**
 * Unified Calendar Header Component
 * Single calendar spine that sits between the chart and tables
 * Provides column alignment for all data below
 */
const UnifiedCalendar = ({ 
    visiblePeriods, 
    periodStartIndex,
    granularity,
    actualPeriodCount,
    gridTemplateColumns 
}) => {
    return (
        <div className="unified-calendar-container">
            <div 
                className="unified-calendar-grid"
                style={{ 
                    gridTemplateColumns: gridTemplateColumns 
                }}
            >
                {/* Empty left column to align with row labels */}
                <div className="calendar-label-column">13-Week Cash Forecast</div>
                
                {/* Period columns - one per grid column */}
                {visiblePeriods.map((period, idx) => {
                    const periodIndex = periodStartIndex + idx;
                    const isActual = isActualPeriod(periodIndex, actualPeriodCount);
                    
                    // For forecast periods, start numbering from W1/M1/D1
                    // For actual periods, use their absolute index from the beginning
                    const displayIndex = isActual ? periodIndex : periodIndex - actualPeriodCount;
                    
                    // Highlight the first forecast period (W1)
                    const isFirstForecast = !isActual && displayIndex === 0;
                    
                    return (
                        <div key={period} className={`calendar-period ${isActual ? 'actual' : 'forecast'} ${isFirstForecast ? 'first-forecast' : ''}`}>
                            <div className="period-label">
                                {isActual ? null : getPeriodPrefix(displayIndex, granularity)}
                            </div>
                            <div className={`period-phase ${isActual ? 'actual' : 'forecast'}`}>
                                {isActual ? 'ACTUAL' : 'FORECAST'}
                            </div>
                            <div className="period-content">
                                <div className="period-date">
                                    {formatPeriodLabel(period, granularity)}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default UnifiedCalendar;

